import { Component, signal } from '@angular/core';
import {BackgroundComponent} from '../../../shared/pages/background/background.component';
import { RouterLink  } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-recover-password',
  imports: [FormsModule,RouterLink , BackgroundComponent],
  templateUrl: './recover-password.component.html',
})
export class RecoverPasswordComponent {
 
  email       = signal<string|null>(null);

  showValues(){
    console.log(this.email()
   );
  }

  set emailModel(value: string) {
    this.email.set(value);
  }

  

}
